import { Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetExpectedCommissions } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

type TProps = {
  applicationId: string;
  offerId?: string;
  isLoadingPayments: boolean;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
};

export const RepeatCommission = ({
  applicationId,
  offerId,
  isLoadingPayments,
  offerIsSelected,
  offerNotSelected,
}: TProps) => {
  const { introducerId } = useIntroducerData();
  const { formatPercentage } = useNumberFormat();

  const { data: expectedCommission, isFetching } = useGetExpectedCommissions(
    introducerId,
    applicationId,
    offerId,
  );

  const formatCommissionRate = () => {
    if (!expectedCommission?.data) {
      return '-';
    }

    const { repeat_rate } = expectedCommission.data;
    return (
      <p
        className={clsx(styles.value, {
          [styles.selectedValue]: offerIsSelected,
          [styles.unselectedValue]: offerNotSelected,
        })}
      >
        {formatPercentage(repeat_rate)}
      </p>
    );
  };

  return (
    <>
      {isLoadingPayments || isFetching ? (
        <div className={styles.loaderContainer}>
          <Spinner />
        </div>
      ) : (
        formatCommissionRate()
      )}
    </>
  );
};
